import Loading from 'components/Loading/index';

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { get } from 'lodash';

const COL_TITLES_MAP = {
  date: 'Дата',
  ip: 'IP-адрес',
  message: 'Действие',
};

export default class ActivityHistory extends Component {
  static propTypes = {
    getHistory: PropTypes.func.isRequired,
    history: PropTypes.shape({}),
  };

  state = {
    full: false,
  };

  componentDidMount() {
    this.props.getHistory();
  }

  toggleFull() {
    this.setState({
      full: !this.state.full,
    });
  }

  renderHeader(month) {
    return (
      <tr>
        <td colSpan="3">
          <h4>{month}</h4>
        </td>
      </tr>
    );
  }

  renderRows(rows) {
    return rows.map((row, index) => <tr key={`row_${index}`}>{this.renderRow(row, index)}</tr>);
  }

  renderRow(row, index) {
    return Object.entries(row).map(([key, val]) => {
      return (
        <td key={`row_${index}_${key}`} className="table_25">
          <div className="table_name grey">{COL_TITLES_MAP[key]}</div>
          <div className="table_param">
            <p // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html: key === 'date' ? val.format('DD.MM.YYYY HH:mm') : val,
              }}
            />
          </div>
        </td>
      );
    });
  }

  renderOneMonth(month) {
    const { history } = this.props;
    const data = get(history, 'data');
    return [this.renderHeader(month), this.renderRows(data[month])];
  }

  renderAllMonth() {
    const { history } = this.props;
    const data = get(history, 'data');

    return Object.keys(data).map((month) => this.renderOneMonth(month));
  }

  renderShowMoreLink() {
    const { history } = this.props;
    const data = get(history, 'data');
    if (Object.keys(data).length < 2) {
      return null;
    }

    const text = this.state.full
      ? 'Скрыть полную историю действий...'
      : 'Показать полную историю действий...';
    return (
      <div>
        <a onClick={() => this.toggleFull()}>{text}</a>
      </div>
    );
  }

  render() {
    const { history } = this.props;
    if (get(history, 'loading') || !get(history, 'data')) {
      return <Loading />;
    }

    const data = get(history, 'data');
    const firstMount = Object.keys(data)[0];

    if (!firstMount) {
      return <h2>Нет истории действий.</h2>;
    }

    return (
      <div className="page__mobile white-block__pad40 pt-0">
        <table className="table text-big page_margin30">
          <thead>
            <tr>
              <th>Дата</th>
              <th>IP-адрес</th>
              <th>Действие</th>
            </tr>
          </thead>
          <tbody>{this.state.full ? this.renderAllMonth() : this.renderOneMonth(firstMount)}</tbody>
        </table>
        {this.renderShowMoreLink()}
      </div>
    );
  }
}
